module.exports = __webpack_public_path__ + "img/list-button.d1271770.svg";